import { classnames } from '@aibees/shared/utils';
import { Icon } from '@aibees/shared/components';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchEnrichmentHistoryProps as Props } from './types';

export const SearchEnrichmentHistory = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      className={classnames('SearchEnrichmentHistory', className)}
      sx={SX.root}
    >
      <Icon name="search" sxx={SX.icon} size={37} />
      <Styled.SearchField placeholder="Search History" />
    </Styled.Wrapper>
  );
});

SearchEnrichmentHistory.displayName = 'SearchEnrichmentHistory';
